export default {
  LEGACY_CLAIMS: {
    EMAIL: 'email',
    NAME: 'name',
    GIVEN_NAME: 'given_name',
    FAMILY_NAME: 'family_name',
    DEBTOR: 'http://ctmportal/debtor',
    DEBTOR_ALT: 'http://travelctm.com/common/claims/debtor',
    DEBTOR_NAME: 'http://ctmportal/debtorName',
    HAS_PASSWORD_EXPIRED: 'http://travelctm.com/common/claims/hasPasswordExpired',
    NEEDS_FEDERATED_LOGOUT: 'http://travelctm.com/common/claims/needsFederatedLogout',
    TRAVELLER_ID: 'http://ctmportal/travellerId',
    ROLES: 'http://ctmportal/roles'
  },

  CLAIMS: {
    APPLICATION_CODE: 'http://ctm.com/applicationCode',
    APPLICATION_ENTITIES: 'http://ctm.com/applicationEntities',
    NAME_IDENTIFIER: 'sub',
    EMAIL: 'http://ctm.com/email',
    FULL_NAME: 'http://ctm.com/fullName',
    FIRST_NAME: 'http://ctm.com/firstName',
    LAST_NAME: 'http://ctm.com/lastName',
    DEFAULT_DEBTOR: 'http://ctm.com/defaultDebtor',
    DEBTOR: 'http://ctm.com/debtor',
    DEBTOR_NAME: 'http://ctm.com/applicationEntityName',
    SCOPE: 'scope',
    HAS_PASSWORD_EXPIRED: 'http://ctm.com/hasPasswordExpired',
    NEEDS_FEDERATED_LOGOUT: 'http://ctm.com/needsFederatedLogout',
    COMMON_EMAIL: 'http://travelctm.com/common/claims/email',
    ROLE_TYPES: 'http://ctm.com/roleTypes',
    ROLE_TYPE_NAME: 'http://ctm.com/roleTypeName',
    EXTERNAL_REFERENCE: 'http://ctm.com/externalReference',
    EMPLOYEE_ID: 'http://ctmportal/employeeId',
    HOME_TITLE: 'https://feed-itinerary.travelctm.com/homeTitle'
  },

  LEGACY_ROLES: {
    ADMIN: "admin",
    TRAVELLER: "traveller",
    TRAVEL_ARRANGER: "travel arranger",
    CLIENT_MANAGER: "client manager",
    CONSULTANT: "consultant",
    DEMO: "demo"
  }
}
